"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.replace");

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _bindAll2 = _interopRequireDefault(require("lodash/bindAll"));

var _memoize2 = _interopRequireDefault(require("lodash/memoize"));

var _isNaN2 = _interopRequireDefault(require("lodash/isNaN"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ismobilejs = _interopRequireDefault(require("ismobilejs"));

var _reactInput = _interopRequireDefault(require("@nerdwallet/react-input"));

var _num = _interopRequireDefault(require("./num"));

var _splitDateInput = _interopRequireDefault(require("./split-date-input"));

var _formatPatternFactory = _interopRequireDefault(require("./format-pattern-factory"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Wrapper for an input for easy formatting, while still preserving
 * unformatted value.
 *
 * Some format types make use of manual caret position state management which means we
 * control the position of the cursor within the input as the user interacts with it.
 * This is needed whenever our formatting functions add or remove extra characters that
 * the user did not input ie. adding slashes as the user types a date.
 *
 * @class
 *
 * @property {object} props - The props for a given react component.
 * @property (string) formatType - The formatting type for the given input field.
 * @property {*} value - The value that needs to be formatted on the input field.
 * @property {boolean} skipFormatPlaceholder - Optional boolean to skip applying format function to placeholder.
 * @property {*} placeholder - The value that needs to be used as a formatted placeholder on the input field.
 * @property {function} onChange - The on change hook for the input.
 * @property {number=} min - Optional min value for the input field to constrain.
 * @property {number=} max - Optional max value for the input field to constrain.
 * @property {boolean=} error - Whether the input is in an error state.
 * @property {number=} maxLength - Optional max length of input value.
 * @property {boolean} splitDate - Render the split date input. formatType must be 'date' as well.
 */
function titleize(string) {
  var res = string.replace(/([A-Z])/g, ' $1');
  return (res.charAt(0).toUpperCase() + res.slice(1)).replace(/\s/g, '');
}

var FormattedInput =
/*#__PURE__*/
function (_Component) {
  _inherits(FormattedInput, _Component);

  _createClass(FormattedInput, null, [{
    key: "constrainValue",

    /* eslint-disable react/require-default-props, react/forbid-prop-types */

    /* eslint-enable react/require-default-props, react/forbid-prop-types */
    value: function constrainValue(valueToConstrain, _ref) {
      var formatType = _ref.formatType,
          min = _ref.min,
          max = _ref.max;
      var value = valueToConstrain;

      switch (formatType) {
        case 'currency':
          // We assume that both min and max are required to constrain. If requirements change, we can make it handle either one
          if (min !== undefined && max !== undefined) {
            value = _num.default.constrain(value, min, max);
          }

          break;

        default: // Different types will have to be formatted differently

      }

      return value;
    }
  }, {
    key: "formatAlphabet",
    value: function formatAlphabet(input) {
      var value = input.value.replace(/[^a-zA-Z]/g, '');
      return {
        formattedValue: value,
        value: value
      };
    }
  }, {
    key: "formatCurrency",
    value: function formatCurrency(currencyInput) {
      var caret = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var prevState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var input = currencyInput;
      var originalInput = input.value;
      var previousValue = prevState.formattedValue;
      var currency = props.currencyPrefix;
      var returnCaret;
      var currencyPosition;

      if (input.value.length) {
        currencyPosition = input.value.indexOf(currency); // if no currency, add it

        if (currencyPosition === -1) {
          input.value = currency + input.value;
        } // if currency is not at the beginning, user is typing at beginning


        if (currencyPosition > 0) {
          // swap input before currency with currency (e.g. `3$400` => `$3400`)
          input.value = currency + input.value.substr(0, currencyPosition) + input.value.slice(currencyPosition + currency.length); // set caret to after both of those

          returnCaret = currencyPosition + currency.length;
        } // this should only happen when they are hitting backspace, and we want to clear the currency


        if (input.value === currency) {
          input.value = '';
        } else {
          var noCommasValue = input.value.replace(/\..*$/, '').replace(/\D/g, '');
          var tmp = FormattedInput.constrainValue(parseInt(noCommasValue, 10), props); // This allows the user to change $5,000,000 to $4,000,000 without it resetting to $0 when they delete the 5

          if (tmp === 0) {
            tmp = noCommasValue;
          }

          if (!(0, _isNaN2.default)(tmp)) {
            input.value = currency + tmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          } else {
            input.value = '';
          } // The first time - input.previousValue will be undefined and we don't need to test for backwards anyway.


          if (caret && previousValue) {
            var isBackwards = originalInput.length < previousValue.length;

            if (isBackwards) {
              // Here we want to let the user delete their comma without doing any formatting for them
              if (previousValue[caret] === ',') {
                input.value = originalInput;
              }
            }
          }
        }
      }

      return {
        formattedValue: input.value,
        value: input.value.replace(/\D/g, ''),
        returnCaret: returnCaret
      };
    }
  }, {
    key: "formatDate",
    value: function formatDate(input, caret, prevState) {
      // TODO: return patternFormatter output directly in next major version (^9)
      var formatFn = FormattedInput.patternFormatter('99/99/9999');

      var previousState = _objectSpread({}, prevState, {
        // pass raw value as state value to formatter
        value: formatFn.pattern.extract(prevState.formattedValue)
      });

      var out = formatFn(input, caret, previousState); // overwrite raw value with formattedValue
      // to keep backwards compatibility

      out.value = out.formattedValue;
      return out;
    }
  }, {
    key: "formatNone",
    value: function formatNone(input) {
      return {
        formattedValue: input.value,
        value: input.value
      };
    }
  }, {
    key: "formatNumber",
    value: function formatNumber(input) {
      var value = input.value.replace(/\D/g, '');
      return {
        formattedValue: value,
        value: value
      };
    }
    /**
     * Format handler to format inputs as percentages.
     *
     * @param input
     * @param caret
     * @param {?object} prevState the state of the component as it existed when formatting method is invoked
     * @param {String} src Determines the source of the change that triggered this format - so that we can treat user interactions different from calculation interactions.
     * @returns {*}
     */

  }, {
    key: "formatPercentage",
    value: function formatPercentage(percentageInput, caret, prevState, props, src) {
      var input = percentageInput;
      var length = input.value.length;
      var stateFormattedValue = prevState && prevState.formattedValue;
      var formatterStr = '0.[000]%';

      try {
        var currentValue = '';
        var shouldFormatInput = false; // Is the input not empty ?

        if (length) {
          var lastCharacter = input.value[length - 1]; // numeral js fails when a user enters 2 decimal points - works for everything else :D

          currentValue = _num.default.value(input.value); // If the last character is not a percent sign, add it!

          if (lastCharacter !== '%') {
            // Did the user just try to remove the % ? Or if the user tries to input a number - very likely they're inputting it as percent values.
            if ("".concat(input.value, "%") === stateFormattedValue || currentValue >= 1 && src === 'user-input') {
              currentValue /= 100;
            }

            shouldFormatInput = true;
          } else if (stateFormattedValue.replace('.', '') === input.value) {
            // Special case where the user tries to delete the decimal point - revert back to the previous value.
            currentValue = _num.default.value(stateFormattedValue);
            shouldFormatInput = true;
          } else {
            // We should format the input if the user inputs anything other than a number for a decimal
            shouldFormatInput = !/^[0-9]+([.][0-9]*)?[%]$/g.test(input.value);
          }
        } // Should we format the input ?


        if (shouldFormatInput) {
          input.value = _num.default.formatPercent(currentValue, formatterStr);
        }

        return {
          formattedValue: input.value,
          value: currentValue
        };
      } catch (e) {
        // In case of an error where the currentValue is NaN - reset to previous state or default state.
        return prevState || {
          formattedValue: '',
          value: 0
        };
      }
    }
  }, {
    key: "formatPhoneNumber",
    value: function formatPhoneNumber(input, caret, prevState) {
      return FormattedInput.patternFormatter('+1 (999) 999-9999')(input, caret, prevState);
    }
  }, {
    key: "formatSsn",
    value: function formatSsn(input, caret, prevState) {
      return FormattedInput.patternFormatter('999-99-9999')(input, caret, prevState);
    } // patterns:
    //  '9' is numeral
    //  'a' is alpha
    //  'x' is all (alphanumeric?)
    //  any other character is a delimiter in the pattern

  }, {
    key: "unmask",
    // reconstruct full formattedValue string from changes to a value in the DOM,
    // regardless of whether DOM value is masked or not
    value: function unmask(prevValue, newValue, prevSelection, newSelection) {
      // when a `formatFn` returns a `maskedValue`, that value is rendered in the input in the DOM
      // and when a maskedValue is rendered in the DOM, like `***-**-655`,
      // this method is necessary to reformat the `formattedValue` state with the characters
      // that the user has added or removed.  otherwise formatters will be trying to process
      // changes to masked values, like `**565*-**-655`.  no bueno.
      var selectionStartDiff = newSelection[0] - prevSelection[0];
      var selectionEndDiff = newSelection[1] - prevSelection[1];
      var removedCt = Math.max(selectionStartDiff - selectionEndDiff, -1 * selectionEndDiff);
      var removedPosition = [prevSelection[1] - removedCt, prevSelection[1]];
      var addedCt = Math.max(0, selectionStartDiff);
      var addedPosition = [newSelection[1] - addedCt, newSelection[1]];
      var addedChars = newValue.slice(addedPosition[0], addedPosition[1]); // insert the changes into the previous (not-masked) value

      return prevValue.slice(0, removedPosition[0]) + addedChars + prevValue.slice(removedPosition[1], prevValue.length);
    } // masks a formatted value with the maskStr
    // maskStr: string to overlay over val
    // val: string to mask
    // selection: range of characters to leave unmasked

  }, {
    key: "mask",
    value: function mask() {
      var maskStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var val = arguments.length > 1 ? arguments[1] : undefined;
      var selection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [0, 0];

      if (!maskStr.length) {
        return val;
      } // early return


      var mask = '';
      var maskLength = val.slice(0, maskStr.length).length; // only test chars that could potentially be masked

      for (var i = 0; i < maskLength; i += 1) {
        // char in range of selection? yes: print the actual character, no: print the mask character
        mask += i >= selection[0] && i < selection[1] ? val[i] : maskStr[i];
      }

      return mask + val.slice(maskLength, val.length); // processed mask + remaining chars in value string
    }
  }]);

  function FormattedInput(props) {
    var _this;

    _classCallCheck(this, FormattedInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormattedInput).call(this, props));
    (0, _bindAll2.default)(_assertThisInitialized(_this), ['onBlur', 'onChange', 'onFocus', 'onDocumentSelectionChange']);
    _this.formatFn = null;
    _this.formatMask = null;
    _this.selection = [0, 0];
    _this.maskSelection = [0, 0];
    _this.maskCaret = 0;
    _this.formattedValue = '';
    _this.value = '';
    _this.state = _this.updateState(props);
    return _this;
  }

  _createClass(FormattedInput, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState(this.updateState(nextProps));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // just to be super safe unbind when component is destroyed
      document.removeEventListener('selectionchange', this.onDocumentSelectionChange);
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      document.addEventListener('selectionchange', this.onDocumentSelectionChange);
      this.props.onFocus.call(this, e);
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      document.removeEventListener('selectionchange', this.onDocumentSelectionChange);

      if (this.props.formatTriggerEvent === 'blur') {
        this.formatEvent(e, this.props.onBlur);
      } else {
        this.props.onBlur.call(this, e);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      if (this.props.formatTriggerEvent === 'change') {
        this.formatEvent(e);
      } else {
        // determine new input value from changes to input DOM element
        // reconstruct the non-masked formatted value from the changes
        var selection = [e.target.selectionEnd, e.target.selectionEnd];
        this.formattedValue = this.unmaskInputValue(e.target.value, selection); // update formatted value

        this.setState({
          maskedValue: e.target.value
        }); // update maskedValue for render
      }
    } // this method is bound to document 'selectionchange'
    // on focus and unbound on blur

  }, {
    key: "onDocumentSelectionChange",
    value: function onDocumentSelectionChange() {
      // find the input element and read its selection range
      this.changeStateSelection(this.input.selectionStart, this.input.selectionEnd);
    }
  }, {
    key: "changeStateSelection",
    value: function changeStateSelection(selectionStart, selectionEnd) {
      if (selectionStart !== this.selection[0] || selectionEnd !== this.selection[1]) {
        this.selection = [selectionStart, selectionEnd];
      }
    }
  }, {
    key: "formatEvent",
    value: function formatEvent(e, callback) {
      var _this2 = this;

      var caret = e.target.selectionEnd;
      var selection = [e.target.selectionEnd, e.target.selectionEnd];
      var preFormat = e.target.value.length;
      var atEnd = preFormat === caret;

      if (this.props.maxLength && preFormat > this.props.maxLength) {
        return;
      } // determine new input value from changes to input DOM element
      // reconstruct the non-masked formatted value from the changes


      var unmaskedValue = this.unmaskInputValue(e.target.value, selection); // run the formatter

      var formatState = {
        formattedValue: this.formattedValue,
        value: this.value
      };
      var formatted = this.formatFn({
        value: unmaskedValue
      }, caret, formatState, this.props, 'user-input');
      var formattedValue = formatted.formattedValue,
          value = formatted.value,
          returnCaret = formatted.returnCaret;
      var postFormat = formattedValue.length; // Optional manual caret management, only applies if formatFn returns the field `caret`

      var newCaret = caret;

      if (returnCaret) {
        newCaret = returnCaret;
      } else if (atEnd) {
        newCaret = postFormat;
      } else {
        // the actual input is nested a little bit
        var diff = postFormat - preFormat;
        newCaret += diff;
      } // save raw, unformatted value in element's dataset.


      e.target.dataset.rawValue = value; // persist the react SyntheticEvent to use it asynchronously in the setState callBack

      e.persist(); // get a reference to current value in state for onChange fire comparison

      var prevValue = this.value; // update instance variables

      var maskSelectionStart = (0, _get2.default)(this, 'selection[0]', newCaret || 0);
      this.maskSelection = [maskSelectionStart, newCaret];
      this.maskCaret = caret;
      this.selection = [newCaret, newCaret];
      this.formattedValue = formattedValue;
      this.value = value; // set new maskedValue in state for render

      this.setState({
        maskedValue: FormattedInput.mask(this.formatMask, formattedValue, this.maskSelection)
      }, function () {
        var setSelectionRange = function setSelectionRange() {
          var domNode = _this2.input; // Prevents iOS bug where setting selection range on an inactive element completely breaks the page

          if (domNode === document.activeElement) {
            domNode.setSelectionRange(newCaret, newCaret, 'none');
          } // fire event handlers after selectionRange has been properly set


          if (value !== prevValue) {
            // has the raw value changed?
            _this2.props.onChange.call(_this2, e);
          }

          if (callback) {
            callback.call(_this2, e);
          }
        }; // android keyboards sometimes have buggy behavior
        // when reporting selection ranges
        // it's a head-scratcher for sure, but a simple solution
        // is to defer the setting of the selectionRange
        // until next tick.
        // some interesting discussion here:
        // https://github.com/text-mask/text-mask/issues/300#issuecomment-282293346


        if ((0, _get2.default)(_ismobilejs.default, 'android.device')) {
          setTimeout(setSelectionRange, 0);
        } else {
          setSelectionRange();
        }
      });
    }
  }, {
    key: "unmaskInputValue",
    value: function unmaskInputValue(newValue, newSelection) {
      var prevSelection = this.selection;
      var prevValue = this.formattedValue;

      if (prevValue.length !== newValue.length && (0, _isEqual2.default)(prevSelection, newSelection)) {
        // user pressed the delete key with no text selected
        prevSelection[1] += prevValue.length - newValue.length;
      }

      return FormattedInput.unmask(prevValue, newValue, prevSelection, newSelection);
    }
  }, {
    key: "updateState",
    value: function updateState(props) {
      var formatPattern = props.formatPattern,
          formatMask = props.formatMask;
      var formatType = props.formatType;

      if (formatType === 'pattern' && !formatPattern) {
        throw new Error('formatPattern required for formatType="pattern"');
      } else if (formatPattern) {
        formatType = 'pattern';
        this.formatFn = FormattedInput.patternFormatter(formatPattern);
      } else {
        this.formatFn = FormattedInput["format".concat(titleize(props.formatType))];
      }

      if (!this.formatFn) {
        this.formatFn = FormattedInput.formatNone;

        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn("No formatFn for type: ".concat(formatType, ". Using formatNone."));
        }
      }

      var valueToFormat = "".concat((0, _get2.default)(props, 'value', '')); // ensure prop value is a string

      var formatState = {
        formattedValue: this.formattedValue || valueToFormat,
        value: this.value
      }; // run the format method on the value property with the props and format state

      var formatted = this.formatFn({
        value: valueToFormat
      }, this.maskCaret, formatState, props);
      var formattedValue = formatted.formattedValue,
          value = formatted.value; // update instance formatMask, ssn type is masked by default

      this.formatMask = formatType === 'ssn' && formatMask === undefined ? '•••-••-' : formatMask;
      this.formattedValue = formattedValue;
      this.value = value; // return new state with maskedValue

      return {
        maskedValue: FormattedInput.mask(this.formatMask, formattedValue, this.maskSelection)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          formatType = _this$props.formatType,
          splitDate = _this$props.splitDate;

      if (formatType === 'date' && splitDate) {
        return _react.default.createElement(_splitDateInput.default, this.props);
      }

      var placeholder = this.props.placeholder || '';

      if (!this.props.skipFormatPlaceholder) {
        placeholder = this.formatFn({
          value: "".concat(placeholder)
        }, null, {}, this.props).formattedValue;
      }

      var props = (0, _omit2.default)(this.props, ['skipFormatPlaceholder', 'formatType', 'formatPattern', 'formatMask', 'formatTriggerEvent', 'currencyPrefix', 'caret', 'splitDate']);
      return _react.default.createElement(_reactInput.default, _extends({}, props, {
        inputRef: function inputRef(input) {
          _this3.input = input;
        },
        onChange: this.onChange,
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        value: this.state.maskedValue,
        error: this.props.error,
        placeholder: placeholder
      }));
    }
  }]);

  return FormattedInput;
}(_react.Component);

exports.default = FormattedInput;

_defineProperty(FormattedInput, "displayName", 'FormattedInput');

_defineProperty(FormattedInput, "propTypes", {
  currencyPrefix: _propTypes.default.string,
  // allows for custom currency prefix, like 'US $', '₹' or even ''
  error: _propTypes.default.bool,
  formatMask: _propTypes.default.string,
  formatPattern: _propTypes.default.string,
  formatTriggerEvent: _propTypes.default.string,
  formatType: _propTypes.default.string,
  max: _propTypes.default.number,
  maxLength: _propTypes.default.number,
  min: _propTypes.default.number,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  placeholder: _propTypes.default.any,
  skipFormatPlaceholder: _propTypes.default.bool,
  splitDate: _propTypes.default.bool,
  value: _propTypes.default.any
});

_defineProperty(FormattedInput, "defaultProps", {
  currencyPrefix: '$',
  formatPattern: null,
  formatType: 'currency',
  formatTriggerEvent: 'change',
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {}
});

_defineProperty(FormattedInput, "patternFormatter", (0, _memoize2.default)(_formatPatternFactory.default));